/*
  Dekogreen · buscador (28-09-2026). Engancha las reglas de dk-buscador-reglas.js al componente
  predictive-search de Be Yours sin tocar su archivo: sustituye getSearchResults y añade dkPintar.
*/
(function () {
  var R = window.DKBuscador;
  var PS = window.customElements && window.customElements.get('predictive-search');
  if (!R || !PS) return;

  var nodoCfg = document.getElementById('dk-buscador-config');
  var CFG = {};
  try { CFG = JSON.parse(nodoCfg ? nodoCfg.textContent : '{}'); } catch (e) {}
  var MAPA = R.leerMapa(CFG.mapa || '');
  var SIN = R.leerSinonimos(CFG.sinonimos || '');
  var RAIZ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Colecciones fijadas que fallaron (errata en el ajuste, sin fichas): ni se piden otra vez ni se va a ellas con Intro
  var ROTOS = {};
  function fijarVivo(termino) {
    var f = R.fijar(termino, MAPA, SIN);
    return f && !ROTOS[f.handle] ? f : null;
  }
  // El buscador del modal está cerrado: una respuesta que llega tarde no se pinta (volvería a poner la capa gris)
  function cerrado(ps) {
    var d = ps.closest('details');
    return !!d && !d.hasAttribute('open');
  }

  function medir(nombre, datos) { if (typeof window.dkMedir === 'function') window.dkMedir(nombre, datos); }
  // Cada búsqueda se apunta una vez, cuando el cliente termina (1,5 s sin escribir, toca, pulsa Intro o cierra)
  var anotador = R.crearAnotador(function (d) {
    medir('dk_buscador_busqueda', { termino: d.termino, fichas: d.fichas, coleccion: d.coleccion });
    if (d.vacio) medir('dk_buscador_sin_resultado', { termino: d.termino });
  }, 1500);

  function contador(ps, texto) {
    var c = ps.predictiveSearchResults.querySelector('[data-predictive-search-live-region-count-value]');
    if (!c) {
      c = document.createElement('span');
      c.className = 'hidden';
      c.setAttribute('data-predictive-search-live-region-count-value', '');
      ps.predictiveSearchResults.appendChild(c);
    }
    c.textContent = texto;
  }

  function urlPredictiva(ps, termino) {
    return theme.routes.predictive_search_url + '?q=' + encodeURIComponent(termino) +
      '&' + encodeURIComponent('resources[limit]') + '=' + (ps.dataset.perPage || 6) +
      '&' + encodeURIComponent('resources[limit_scope]') + '=each&section_id=predictive-search';
  }

  function pedir(url, idSeccion) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (html) {
      var nodo = new DOMParser().parseFromString(html, 'text/html').querySelector('#shopify-section-' + idSeccion);
      if (!nodo || !nodo.querySelector('[data-predictive-search-live-region-count-value]')) throw new Error('sin sección');
      if (idSeccion === 'dk-buscador-coleccion' && !nodo.querySelector('[data-dk-coleccion]')) throw new Error('colección vacía');
      return nodo.innerHTML;
    });
  }

  PS.prototype.getSearchResults = function (termino) {
    var ps = this;
    if (cerrado(ps)) return;
    var fijado = fijarVivo(termino);
    var clave = (fijado ? 'c:' + fijado.handle : 'q:') + R.normalizar(termino);
    ps.setLiveRegionLoadingState();
    if (ps.cachedResults[clave]) { ps.dkFijado = fijado; ps.dkPintar(ps.cachedResults[clave], termino); return; }

    var promesa = fijado
      ? pedir(RAIZ + 'collections/' + encodeURIComponent(fijado.handle) + '?section_id=dk-buscador-coleccion', 'dk-buscador-coleccion')
          .catch(function () { ROTOS[fijado.handle] = true; fijado = null; return pedir(urlPredictiva(ps, termino), 'predictive-search'); })
      : pedir(urlPredictiva(ps, termino), 'predictive-search');

    promesa.then(function (html) {
      if (R.normalizar(ps.getQuery()) !== R.normalizar(termino)) return; // ya se escribió otra cosa
      ps.cachedResults[(fijado ? 'c:' + fijado.handle : 'q:') + R.normalizar(termino)] = html;
      if (cerrado(ps)) return;
      ps.dkFijado = fijado;
      ps.dkPintar(html, termino);
    }).catch(function () { ps.close(); });
  };

  PS.prototype.dkPintar = function (html, termino) {
    var ps = this;
    var caja = ps.predictiveSearchResults;
    caja.innerHTML = html;
    var filas = [].slice.call(caja.querySelectorAll('[data-dk-texto]'));
    var res = { visibles: filas.map(function (_, i) { return i; }), corregido: null, sinFiltro: true };
    if (!ps.dkFijado) {
      res = R.filtrar(filas.map(function (a) { return { texto: a.getAttribute('data-dk-texto') }; }), termino, SIN);
      filas.forEach(function (a, i) { if (res.visibles.indexOf(i) === -1) a.closest('li').remove(); });
    }
    var corregido = ps.dkFijado ? ps.dkFijado.corregido : res.corregido;
    var aviso = caja.querySelector('[data-dk-corregido]');
    if (aviso) {
      aviso.hidden = !corregido;
      if (corregido) aviso.querySelector('[data-dk-palabra]').textContent = corregido;
    }
    var quedan = caja.querySelectorAll('[data-dk-texto]').length;
    var sugerencias = caja.querySelectorAll('#predictive-search-results-queries-list li, .predictive-search__pages-wrapper li').length;
    var listaFichas = caja.querySelector('#predictive-search-results-products-list');
    if (listaFichas && !listaFichas.children.length) listaFichas.parentElement.remove(); // sin el titular «Productos» vacío
    var sin = caja.querySelector('[data-dk-sin-resultado]');
    // «No encuentro» solo si no queda nada (ni fichas ni colecciones sugeridas) y ya hay 3 letras o más
    var vacio = quedan === 0 && sugerencias === 0 && !res.sinFiltro;
    if (sin) sin.hidden = !vacio;
    if (sin && vacio) {
      var t = sin.querySelector('[data-dk-termino]');
      if (t) t.textContent = termino;
      var wa = sin.querySelector('[data-dk-whatsapp]');
      if (wa && CFG.whatsapp) wa.href = 'https://wa.me/' + CFG.whatsapp + '?text=' + encodeURIComponent('Hola, Antonio: busco ' + termino);
      var grupos = caja.querySelector('#predictive-search-results-groups-wrapper');
      if (grupos) grupos.remove();
      var buscarTodo = caja.querySelector('#predictive-search-option-search-keywords'); // /search contradiría el «No encuentro»
      if (buscarTodo) buscarTodo.remove();
      if (ps.closest('.header') && window.matchMedia('(min-width: 990px)').matches) {
        [].forEach.call(sin.querySelectorAll('.dk-terminos, .dk-fila--todas'), function (n) { n.remove(); });
      }
    }
    var ver = caja.querySelector('[data-dk-ver]');
    if (ver) ver.textContent = 'Ver los ' + ver.getAttribute('data-total') + ' de ' + (corregido || termino.trim());
    contador(ps, vacio ? 'No encuentro ' + termino : quedan + ' resultados');
    ps.setAttribute('results', true);
    ps.setLiveRegionResults();
    ps.open();
    if (ps.modal) ps.modal.classList.add('searching');

    anotador.anotar({ termino: R.sanear(termino), fichas: quedan, coleccion: ps.dkFijado ? ps.dkFijado.handle : '', vacio: vacio });

    var primera = caja.querySelector('[data-dk-texto]');
    ps.dispatchEvent(new CustomEvent('dk:resultados', { bubbles: true, detail: { primera: primera ? {
      img: primera.getAttribute('data-dk-img'), nombre: primera.getAttribute('data-dk-nombre'),
      medida: primera.getAttribute('data-dk-medida'), precio: primera.getAttribute('data-dk-precio'),
      sello: primera.hasAttribute('data-dk-sello') } : null } }));
  };

  var cerrarTema = PS.prototype.close;
  PS.prototype.close = function (vaciar) {
    if (vaciar) anotador.descartar(); else anotador.soltar();
    return cerrarTema.apply(this, arguments);
  };
  window.addEventListener('pagehide', function () { anotador.soltar(); });
  // Si sigue escribiendo, la búsqueda anterior no estaba terminada: se descarta y cuenta la que se pinte después
  document.addEventListener('input', function (e) {
    if (e.target.closest && e.target.closest('predictive-search')) anotador.descartar();
  }, true);
  // Tocar un resultado, un término o un botón del buscador da por terminada la búsqueda que había
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('a, button');
    if (t && t.closest('predictive-search')) anotador.soltar();
  }, true);

  // «Lo más buscado»: el botón escribe la palabra y busca, sin abrir el teclado si el campo no tenía el foco
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-dk-buscar]');
    if (!b) return;
    // El buscador más cercano que rodee al botón: el del modal en la cabecera, el de la página en la 404
    var ps = b.closest('predictive-search');
    for (var caja = b.parentElement; !ps && caja; caja = caja.parentElement) ps = caja.querySelector('predictive-search');
    if (!ps) return;
    e.preventDefault();
    ps.input.value = b.getAttribute('data-dk-buscar');
    ps.onChange();
  });

  // Intro: si hay colección fijada, se va a la colección; si no, a la página de resultados de siempre
  document.addEventListener('submit', function (e) {
    var ps = e.target.closest && e.target.closest('predictive-search');
    if (!ps || e.defaultPrevented) return;
    anotador.soltar();
    // Fila elegida con las flechas: la usa el tema al soltar Intro (abre la ficha o busca la palabra); nunca /search
    if (ps.querySelector('[aria-selected="true"] a, [aria-selected="true"] button')) { e.preventDefault(); return; }
    // «No encuentro»: Intro no lleva a ningún sitio. En pantallas táctiles cierra el teclado: el foco pasa al aviso,
    // dentro del buscador, y no se cierra; con ratón el foco se queda en el campo para seguir escribiendo
    var sin = ps.querySelector('[data-dk-sin-resultado]');
    if (sin && !sin.hidden && ps.getAttribute('open')) {
      e.preventDefault();
      if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) {
        sin.setAttribute('tabindex', '-1');
        sin.focus({ preventScroll: true });
      }
      return;
    }
    var fijado = fijarVivo(ps.getQuery());
    if (fijado) {
      e.preventDefault();
      window.location.href = RAIZ + 'collections/' + encodeURIComponent(fijado.handle);
    }
  }, true);
})();
